export default __webpack_public_path__ + "static/media/obj2.45e5e27d.jpg";